export * from './svedPredstDossier.component';
export * from './svedPredstDossier.service';
